// 共通フッターコンポーネント
export function Footer() {
  return `
    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-logo">反響成約マスター</div>
        <nav class="footer-nav">
          <a href="/privacy.html">プライバシー</a>
          <a href="/site-policy.html">サイトポリシー</a>
          <a href="/company.html">運営会社</a>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSfxt8-DAq1Aj0MacSbBSWeBW2BxoIxsk2QkDIkxWDBuLvlY3Q/viewform" target="_blank" rel="noopener noreferrer">お問い合わせ</a>
        </nav>
        <p class="footer-company">運営：株式会社南勝</p>
        <p class="copyright">Copyright © 2025 株式会社南勝. All Rights Reserved.</p>
      </div>
    </footer>
  `;
}